<div class="app" [ngClass]="{ 'app--ready': status === 'READY', 'app--not-ready': status !== 'READY' }">
  @if (showUnderConstructionPage()) {
    <ftr-under-construction />
  } @else {
    <ng-container #designSystemOverlayContainer />

    <div class="app__display">
      @if (routeData?.noWrapper) {
        <router-outlet />
      } @else {
        <ftr-app-display
          [showNavigationRedesign]="showNavigationRedesign"
          [hasSideNavigation]="!routeData?.hideSideNav"
          [routeData]="routeData"
          (konami)="showTippy()"
        >
          <router-outlet />
        </ftr-app-display>
      }
    </div>
    <div class="app__loader">
      <ftr-app-loader />
    </div>
    <ftr-app-navigation-loader />

    @defer {
      <div id="report-export-portal-container"></div>
      <ftr-dialog />
      <ftr-portal />
    }

    <ftr-toast-container />
    @if (isInDesktopApp) {
      <ftr-update-app-toast />
    }
    <ftr-post-login-notification />
    <ftr-mfa-setup-modal />
    <ftr-confirmation-modal />

    @if (isTippyShown) {
      <ftr-tippy (clickOutside)="isTippyShown = false" />
    }
  }
  <svg-icon class="inlineSVG" src="/assets/images/svgs/svgs.svg" />
</div>
